// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__KTxpt","info":"UpdateTermsInfo_info__3LP9g"};